<template>
  <div>
    <!-- banner -->
    <div class="carousel_wrap">
      <el-carousel height="37vw" loop arrow="never" class="hidden-xs-only">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.img" alt="" class="img_item" loading="lazy" />
          <div class="tips_font">
            <h1>{{ item.line1 || "" }}</h1>
            <h1>{{ item.line2 || "" }}</h1>
          </div>
        </el-carousel-item>
      </el-carousel>
      <el-carousel height="50vw" loop arrow="never" class="hidden-sm-and-up">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.img" alt="" class="img_item" loading="lazy" />
          <div class="tips_font">
            <h1>{{ item.line1 || "" }}</h1>
            <h1>{{ item.line2 || "" }}</h1>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 系统列表 -->
    <div class="system-container">
      <div class="system" v-for="(item, index) in systemList" :key="index">
        <h1>{{ item.name }}</h1>
        <div class="system-item">
          <div
            class="item"
            v-for="(listItem, i) in item.list"
            :key="`list` + i"
            @click="showDetails(index, i)"
          >
            <img :src="listItem.img" alt="" class="system-item_item" loading="lazy" />
            <div>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerList: [],
      systemList: []
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      const baseUrl = process.env.VUE_APP_PUBLIC_PATH

      fetch(baseUrl+'/product/data.json')
        .then(response => response.json())
        .then(data => {
          let { banners, products } = data
          this.bannerList = banners
          this.systemList = products
        })
        .catch(error => console.error('Error loading JSON:', error));
    },
    showDetails(index, i) {
      console.log("click showDetail", index)
      // 传递 customerTypeIndex（哪类客户） customerIndex （第几个）
      this.$router.push({ path: "/productionDetail/1", query: { customerTypeIndex: index, customerIndex: i } })
    }
  },
}
</script>

<style lang="scss" scoped>
.carousel_wrap {
  position: relative;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .tips_font {
    position: absolute;
    top: 260px;
    left: 300px;
    z-index: 5;
    color: #fff;
    font-size: 25px;
   @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}

.system-container {
  display: flex;
  flex-direction: column;

  .system {
    width: 80%;
    margin: 0 auto;
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    h1 {
      margin-bottom: 30px;
      font-size: 24px;
    }
    .system-item {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      font-size: 20px;
      .item {
        width: 300px;
        height: 400px;
        text-align: center;
        margin-right: 50px;
        border: 1px solid gray;
        box-sizing: border-box;
        margin-bottom: 20px;
       @media screen and (max-width: 768px) {
          width: 220px;
          height: 340px;
        }
        &:hover {
          box-shadow: 3px 3px 3px #00a7ec;
          color: #00a7ec;
        }
        > img {
          width: 100%;
          height: 80%;
          object-fit: contain;
        }
        > div {
          height: 20%;
          display: flex;
          justify-content: center;
          align-items: center;
          border-top: 1px solid gray;
        }
      }
    }
  }
}
</style>